module.exports = __webpack_public_path__ + "img/mobile-bg.e5afe365.jpg";